import { Typography } from '@mui/material';
import { Client } from '@nrdy-marketing-engine/cart/@types/cart-state';
import { EmailField } from '@nrdy-marketing-engine/inputs';
import { Control, UseFormRegister, useFormState } from 'react-hook-form';
import PasswordField from '../../../../../inputs/src/password-field';
import Field from '../../shared/field';
import Link from '../../shared/link';
import Title from '../../shared/title';

function SignInFields({
  control,
  register,
}: {
  control: Control<Client>;
  register: UseFormRegister<Client>;
}) {
  const formState = useFormState<Client>({ control });

  return (
    <>
      <Title variant="h1">Sign In</Title>
      <Field>
        <EmailField
          control={control}
          error={!!formState.errors.email?.message}
          helperText={formState.errors.email?.message}
          rules={{}}
        />
      </Field>
      <Field sx={{ marginBottom: 3 }}>
        <PasswordField
          control={control}
          error={!!formState.errors.password?.message}
          helperText={formState.errors.password?.message}
        />
      </Field>
      <Typography display="block" margin="16px auto" textAlign="center" variant="body2">
        <Link href="/forgot-my-password">Forgot your password?</Link>
      </Typography>
    </>
  );
}

export default SignInFields;
